var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tiao",staticStyle:{"border-left":"5px solid #8CBB77","margin-top":"10px","margin-bottom":"10px","height":"20px","line-height":"20px","font-size":"16px","padding-left":"8px"}},[_vm._v(_vm._s(_vm.neir))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-12c1a52b","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/tiao.vue
// module id = null
// module chunks = 